const BRAND_LABELS: Record<string, string> = {
  amex: 'American Express',
  american_express: 'American Express',
  diners: 'Diners Club',
  discover: 'Discover',
  eftpos_au: 'eftpos',
  jcb: 'JCB',
  mastercard: 'Mastercard',
  unionpay: 'UnionPay',
  visa: 'Visa',
}

export function paymentCardBrandLabel(brand: string): string {
  const key = brand.trim().toLowerCase()
  if (BRAND_LABELS[key]) return BRAND_LABELS[key]
  if (!key) return 'Card'
  return key.charAt(0).toUpperCase() + key.slice(1)
}

export function paymentCardLabel(brand: string, last4: string): string {
  return `${paymentCardBrandLabel(brand)} •••• ${last4}`
}
